// extracted by mini-css-extract-plugin
module.exports = {"register":"RegisterPage_register__1SWMm"};